import { Component } from '@angular/core';

import { CHANGE_EMAIL_LINK_DURATION } from '../../constants/expired-change-email-request.constant';

@Component({
  selector: 'app-expired-change-email-request',
  templateUrl: './expired-change-email-request.component.html',
  styleUrls: ['./expired-change-email-request.component.scss']
})
export class ExpiredChangeEmailRequestComponent {
  public readonly linkLifetime =  CHANGE_EMAIL_LINK_DURATION;
}
